import {ReportModel} from "@fedeltapointofsale/data-client";
import {ProductsSoldReportData} from "./products-sold-report.data";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductsSoldReportModel extends ReportModel<ProductsSoldReportData> {
    constructor(injector: Injector) {
        super(injector, ProductsSoldReportData)
    }
}
